import { render, staticRenderFns } from "./activity_order_page.vue?vue&type=template&id=2473821d&scoped=true"
import script from "./activity_order_page.vue?vue&type=script&lang=js"
export * from "./activity_order_page.vue?vue&type=script&lang=js"
import style0 from "./activity_order_page.vue?vue&type=style&index=0&id=2473821d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473821d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2473821d')) {
      api.createRecord('2473821d', component.options)
    } else {
      api.reload('2473821d', component.options)
    }
    module.hot.accept("./activity_order_page.vue?vue&type=template&id=2473821d&scoped=true", function () {
      api.rerender('2473821d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/activity_order_page.vue"
export default component.exports